import React from 'react';
import { Card, Elevation } from '@blueprintjs/core';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import MainSectionLayout from '../layout/MainSectionLayout';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
});

const CardStyle = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const Unavailable = (props) => {
  return (
    <MainSectionLayout title={TLCode.UNAVAILABILITY_Title}>
      <Container>
        <Card className={CardStyle.toString()} interactive={false} elevation={Elevation.TWO}>
          <p>Système temporaire indisponible</p>
        </Card>
      </Container>
    </MainSectionLayout>
  );
};

const UnavailabilityPage = (props) => {
  return <Unavailable {...props} />;
};

export default UnavailabilityPage;
